import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);
export function BarChart(props) {
    const { data } = props;


    const options = {
        responsive: true,
        plugins: {
            datalabels: {
                color: 'white',
                display: function (context) {
                    return context.dataset.data[context.dataIndex] > 15;
                },
                font: {
                    weight: '500'
                },
            },
            legend: {
                position: 'top',
            },
            title: {
                display: false,
                text: '',
            },
        },
    };

    return (
        <Bar
            className='h'
            options={options}
            data={data}
            plugins={[ChartDataLabels]}
        />
    );
}
